<template>
    <v-card
        outlined
        :color="color"
        style="width: 100vw;position: sticky; left:0; top:0; z-index: 4;"
    >
        <v-card-title
            class="text-h6 font-weight-bold justify-center pa-0"
            :style="{ 'color': textColor }" 
        >
        
            <slot></slot>
        </v-card-title>
    </v-card>
</template>

<script>
export default {
    name: "BAnnouncement",

    props: {
        color: String,
        textColor: String
    }
};
</script>
